import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { NgxMaskModule } from 'ngx-mask';

import { RegisterComponent } from './register.component';
import { RegisterActivationComponent } from './register-activation/register-activation.component';
import { RegisterUserComponent } from './register-user/register-user.component';
import { RegisterSuccessComponent } from './responses/register-success/register-success.component';
import { AppMaterialModule } from 'src/app/app-material.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { RegisterSuccessModalComponent } from './responses/modals/register-success-modal/register-success-modal.component';
import { RegisterResetPasswordFinishComponent } from './register-reset-password-finish/register-reset-password-finish.component';

const routes: Routes = [
  { path: 'success', component: RegisterSuccessComponent },
  { path: 'user', component: RegisterUserComponent },
  { path: 'activation', component: RegisterActivationComponent },
  { path: 'reset-pass', component: RegisterResetPasswordFinishComponent }
];

@NgModule({
  declarations: [
    RegisterComponent,
    RegisterSuccessComponent,
    RegisterSuccessModalComponent,
    RegisterActivationComponent,
    RegisterUserComponent,
    RegisterResetPasswordFinishComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    NgxMaskModule.forChild(),
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    AppMaterialModule,
    DirectivesModule,
  ],
})
export class RegisterModule {}
